module.exports = __webpack_public_path__ + "static/img/room2.8736e10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/room2.png
// module id = U0ba
// module chunks = 0